import { useEffect } from 'react';
import { Property, propertyService, propertyQuery } from '@lib/state';
import { useObservable } from './useObservable';

export function usePropertyGroup(propertyId?: Property['id'] | null) {
  useEffect(() => {
    if (propertyId) {
      propertyService.loadPropertyGroup(propertyId);
    }
  }, [propertyId]);

  return useObservable(propertyQuery.propertyGroup);
}
